import { render, staticRenderFns } from "./XeroSyncErrorAlert.vue?vue&type=template&id=aa6401d4&scoped=true"
import script from "./XeroSyncErrorAlert.vue?vue&type=script&setup=true&lang=ts"
export * from "./XeroSyncErrorAlert.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./XeroSyncErrorAlert.vue?vue&type=style&index=0&id=aa6401d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa6401d4",
  null
  
)

export default component.exports